import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import RichEditor from "../../components/editor/RichEditor";
import {Translate} from "../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../components/elements/LoadingButton";
import SubTitle from "../../components/elements/SubTitle";
import AppAnimate from "../../components/AppAnimate/index";
import AppCard from "../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import {connect, setStore} from "trim-redux";
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import Alert from "@material-ui/lab/Alert/Alert";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import CheckForHavingShop from "../../components/elements/CheckForHavingShop";
import LinearCategoryHolder from "../../components/fields/LinearCategoryHolder/index";
import ImageGallery from "../fileManager/Components/ImageGallery";
import Button from "@material-ui/core/Button/Button";
import PageviewRoundedIcon from '@material-ui/icons/PageviewRounded';
import BrandChooser from "../admin/brands/components/BrandChooser";
import Hidden from "@material-ui/core/Hidden/Hidden";
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import {currencySymbol, worked_statuses} from "../../../config/values";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import Feature from "../../components/elements/Feature";
import GetConfirmationText from "../../components/elements/GetConfirmationText";
import moment from "jalali-moment";
import ProtectedFileUploader from "../fileManager/Components/ProtectedFileUploader";
import SizeChooser from "../../components/fields/SizeChooser";
import CoverChooser from "../../components/fields/CoverChooser";
import WritersChooser from "../writers/WrtiersChooser";
import TranslatorsChooser from "../translators/TranslatorsChooser";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Dialog from "@material-ui/core/Dialog/Dialog";
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
import FieldCounterWithoutBar from "../../components/elements/FieldCounterWithoutBar";
import FilesChooser from "../fileManager/Components/FilesChooser";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import FormControl from "@material-ui/core/FormControl/FormControl";
import LabelChooser from "./components/LabelChooser";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import SingleImageChooser from "../fileManager/Components/SingleImageChooser";
import SingleFileChooser from "../fileManager/Components/SingleFileChooser";
import IconButton from "@material-ui/core/IconButton/IconButton";
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import Menu from "@material-ui/core/Menu/Menu";
import {hasProductLimit, updateRedux, UserHasLimit} from "../../../config/Security";
import AddISBNToBook from "./components/AddISBNToBook";

import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import FullTimeChooserModal from "../../components/elements/FullTimeChooserModal";
import PhysicalProductChooser from "./components/PhysicalProductChooser";
import NarratorsChooser from "../narrators/NarratorsChooser";
import EpisodeMaker from "./components/EpisodeMaker";

class MakeProduct extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
        this.EditorChild = React.createRef();
    }
    state = {
        fields:{
            name:"",
            english_name:"",
            description:"",
            shop_id:this.props.user.role.type === "admin" ? this.props.primary_shop.id : this.props.user.shops.length ? this.props.user.shops[0].id : '',
            shop_name:'',
            price:'',
            priceR:'',
            discount_price:'',
            discount_priceR:'',
            priceWhole:'',
            priceWholeR:'',
            discount_priceWhole:'',
            discount_priceWholeR:'',
            pricing_status:'present',
            inventory_for_wholesale:null,
            warranty:"",
            inventory:null,
            transfer_time:"",
            commission:'',
            weight:'',
            situation:'new',
            physically:'physical',
            publish_year:'',
            publish_turn:'',
            number_of_pages:null,
            total_duration:'',
            isbn:null,
            worked_status:[],
            cover_count:1,
            cover_count_type:'single',
        },
        content:{
            HTML: '',
            RAW: null,
            PlainText: ''
        },
        initial_dialog:true,
        new_item:false,
        rating:4.5,
        advantages:[],
        disadvantages:[],
        thumbnail: null,
        back_cover: null,
        inside_pdf: null,
        brand_id: 0,
        label_id: 0,
        editor_input_text: '',
        is_not_original: 0,
        errors:{},
        keywords:[],
        categories:[],
        categoriesName:[],
        variables:[],
        variables_res:[],
        gallery: [],
        files: [],
        writers: [],
        translators: [],
        narrators: [],
        episodes: [],
        loading: true,
        SubmitLoading: false,
        checkLoading: false,
        publish: true,
        confirmed: true,
        has_wholesale: false,
        featured: false,
        slug: null,
        unique_code: null,
        id:this.props.match.params.id,
        editMode:false,
        percent:'',
        percentWhole:'',
        owner_id:null,
        requested_to_delete:0,
        updated_at:null,
        created_at:null,
        book_file:null,
        size:null,
        cover_type:null,
        existed_product:null,
        no_shop:false,
        product_shop:null,
        MBanchorEl:null,
        MTanchorEl:null,
        MManchorEl:null,
        menu_bottom_open:false,
        has_discount_validity:false,
        discount_price_validity:null,
        related_product:null
    };
    classes = this.props.classes;
    componentDidMount(){
        if(this.state.id){
            this.setState({
                editMode:true,
                initial_dialog:false,
            })
            this.loadData();
        }else{
            let user = this.props.user;
            if(hasProductLimit()){
                if(!UserHasLimit()){
                    this.props.history.push('/my-products')
                }
            }
            this.setState({
                loading:false
            })
        }
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    handleThumbImage(thumbnail){
        this.setState({
            thumbnail: thumbnail
        })
    }
    handleChangePercent(e){
        let percent = e.target.value;
        let fields = this.state.fields;
        let price = this.state.fields.priceR;
        if(!!price){
            fields['discount_priceR'] = price - (price*percent/100);
            fields['discount_price'] = price - (price*percent/100);
        }
        if(parseInt(percent) === 0){
            fields.discount_price = '';
            fields.discount_priceR = '';
            percent = ''
        }
        this.setState({
            percent,
            fields
        })
    }
    handleChangePercentWhole(e){
        let percent = e.target.value;
        let fields = this.state.fields;
        let price = this.state.fields.priceWholeR;
        if(!!price){
            fields['discount_priceWholeR'] = price - (price*percent/100);
            fields['discount_priceWhole'] = price - (price*percent/100);
        }
        if(parseInt(percent) === 0){
            fields.discount_priceWhole = '';
            fields.discount_priceWholeR = '';
            percent = ''
        }
        this.setState({
            percentWhole:percent,
            fields
        })
    }
    async loadData(){
            let loginToken = localStorage.getItem('ACT');
            if(loginToken !== null){
                let config = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`
                    }
                };
                await axios.get(`${defaultVariabls.url}/product/get/${this.state.id}`, config)
                    .then(async response => {
                        this.setState({
                            fields: {
                                name: response.data.name,
                                isbn: response.data.isbn,
                                english_name: response.data.english_name === null ? "" : response.data.english_name ,
                                description: !!response.data.description ? response.data.description : '',
                                commission: !!response.data.commission ? response.data.commission : '',
                                weight: !!response.data.weight ? response.data.weight : '',
                                number_of_pages: !!response.data.number_of_pages ? response.data.number_of_pages : '',
                                total_duration: !!response.data.total_duration ? response.data.total_duration : '',
                                physically: !!response.data.physically ? response.data.physically : '',
                                situation: !!response.data.situation ? response.data.situation : '',
                                publish_year: !!response.data.publish_year ? response.data.publish_year : '',
                                publish_turn: !!response.data.publish_turn ? response.data.publish_turn : '',
                                worked_status: !!response.data.worked_status ? response.data.worked_status.split(',') : [],
                                shop_id: response.data.shop_id,
                                shop_name: response.data.shop.name,
                                price:!!response.data.pricing ? response.data.pricing.price : '',
                                priceR:!!response.data.pricing ? response.data.pricing.price : '',
                                discount_price: !!response.data.pricing ? response.data.pricing.discount_price === null ? "" : response.data.pricing.discount_price : '',
                                discount_priceR: !!response.data.pricing ? response.data.pricing.discount_price === null ? "" : response.data.pricing.discount_price : '',
                                priceWhole:!!response.data.pricing ? response.data.pricing.price_whole : '',
                                priceWholeR:!!response.data.pricing ? response.data.pricing.price_whole : '',
                                discount_priceWhole: !!response.data.pricing ? response.data.pricing.discount_price_whole === null ? "" : response.data.pricing.discount_price_whole : '',
                                discount_priceWholeR: !!response.data.pricing ? response.data.pricing.discount_price_whole === null ? "" : response.data.pricing.discount_price_whole : '',
                                pricing_status: !!response.data.pricing ? response.data.pricing.status === null ? "" : response.data.pricing.status === "soon" ?  response.data.pricing.status : response.data.pricing.inventory > 0 ? "present" : "sold" : '',
                                inventory:!!response.data.pricing ? response.data.pricing.inventory : null,
                                inventory_for_wholesale:!!response.data.pricing ? response.data.pricing.inventory_for_wholesale : null,
                                cover_count:!!response.data.cover_count ? response.data.cover_count : 1,
                                cover_count_type:response.data.cover_count > 1 ? "multi" : "single",

                            },
                            thumbnail: response.data.thumbnail,
                            book_file: response.data.book_file,
                            back_cover: response.data.back_cover,
                            inside_pdf: response.data.inside_pdf,
                            brand_id: response.data.brand_id,
                            label_id: response.data.label_id,
                            content: {
                                HTML: response.data.html,
                                RAW: response.data.raw,
                            },
                            rating: response.data.average_rating,
                            publish: response.data.publish,
                            confirmed: response.data.confirmed,
                            featured: response.data.featured,
                            percent : !!response.data.pricing ? response.data.pricing.discount_price > 0 ? Math.max(0, Math.floor((response.data.pricing.price - response.data.pricing.discount_price)*100/response.data.pricing.price)) : '' : '',
                            percentWhole : !!response.data.pricing ? response.data.pricing.discount_price_whole > 0 ? Math.max(0, Math.floor((response.data.pricing.price_whole - response.data.pricing.discount_price_whole)*100/response.data.pricing.price_whole)) : '' : '',
                            variables_res: response.data.variables,
                            slug: response.data.slug,
                            unique_code: response.data.unique_code,
                            is_not_original: parseInt(response.data.is_not_original),
                            has_wholesale: !!response.data.pricing ? parseInt(response.data.pricing.has_wholesale) : false,
                            owner_id: response.data.user_id,
                            updated_at: response.data.updated_at,
                            created_at: response.data.created_at,
                            size: !!response.data.size ? response.data.size : '',
                            cover_type: !!response.data.cover_type ? response.data.cover_type : '',
                            requested_to_delete: parseInt(response.data.requested_to_delete),
                            translators: !!response.data.translators ? response.data.translators : [],
                            narrators: !!response.data.narrators ? response.data.narrators : [],
                            episodes: !!response.data.episodes ? response.data.episodes : [],
                            writers: !!response.data.writers ? response.data.writers : [],
                            product_shop: response.data.shop,
                            discount_price_validity : !!response.data.pricing ? !!response.data.pricing.discount_price_validity ? response.data.pricing.discount_price_validity  : null : null,
                            has_discount_validity : !!response.data.pricing ? !!response.data.pricing.discount_price_validity : false,
                        })
                        let categoriesTemp=[];
                        let categoriesNameTemp=[];
                        let keywordsTemp=[];
                        let galleryTemp=[];
                        let filesTemp=[];
                        response.data.categories.map(item => {
                            categoriesTemp.push(item.id)
                            categoriesNameTemp.push(item.name)
                            return true
                        })
                        response.data.keywords.map(item => {
                            keywordsTemp.push(item.name);
                            return true
                        });
                        response.data.gallery.map(item =>{
                            galleryTemp.push({
                                src: `${defaultVariabls.uploads}/FileManager/${item.name}_small.${item.extension}`,
                                id: item.id,
                                name: item.name,
                                type: item.type,
                            })
                            return true
                        })
                        response.data.files.map(item =>{
                            filesTemp.push({
                                id: item.id,
                                name: item.name,
                                type: item.type,
                            })
                            return true
                        })
                        await this.setState({
                            categories: categoriesTemp,
                            categoriesName: categoriesNameTemp,
                            keywords: keywordsTemp,
                            gallery: galleryTemp,
                            files: filesTemp,
                            loading: false
                        })
                    }).catch(error => {
                        console.log(error.response)
                        this.props.history.push('/');
                        this.props.enqueueSnackbar(Translate.pageNotFound, {
                            variant: 'error',
                        });
                        this.setState({
                            loading:false
                        })
                    })
            }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleChange(e){
        let {errors,fields,percent,percentWhole} = this.state;
        let target = e.target;
        if(target.name === "price"){
            fields.priceR = target.value.replace(/,/ig, '');
            if(!!fields.discount_priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));

        }else if (target.name === "discount_price") {
            fields.discount_priceR = target.value.replace(/,/ig, '');
            if(!!fields.priceR)
                percent = Math.max(0, Math.floor((fields.priceR - fields.discount_priceR)*100/fields.priceR));
            if(parseInt(fields.discount_priceR) >= parseInt(fields.priceR)){
                fields.discount_price = '';
                fields.discount_priceR = '';
                percent = ''
            }
        }if(target.name === "priceWhole"){
            fields.priceWholeR = target.value.replace(/,/ig, '');
            if(!!fields.discount_priceWholeR)
                percentWhole = Math.max(0, Math.floor((fields.priceWholeR - fields.discount_priceWholeR)*100/fields.priceWholeR));

        }else if (target.name === "discount_priceWhole") {
            fields.discount_priceWholeR = target.value.replace(/,/ig, '');
            if(!!fields.priceWholeR)
                percentWhole = Math.max(0, Math.floor((fields.priceWholeR - fields.discount_priceWholeR)*100/fields.priceWholeR));
            if(parseInt(fields.discount_priceWholeR) >= parseInt(fields.priceWholeR)){
                fields.discount_priceWhole = '';
                fields.discount_priceWholeR = '';
                percentWhole = ''
            }
        }else if(
            target.name === "inventory" ||
            target.name === "weight" ||
            target.name === "inventory_for_wholesale" ||
            target.name === "cover_count" ||
            target.name === "number_of_pages" ||
            target.name === "total_duration" ||
            target.name === "publish_year" ||
            target.name === "publish_turn"
        ){
            if(parseInt(target.value) > 0){
                fields[target.name] = Math.abs(parseInt(target.value));
            }else{
                fields[target.name] = '';
            }
        }else{
            fields[target.name] = target.value;
        }
        errors[target.name] = "";
        this.setState({
            fields,
            percent,
            percentWhole,

        });
    }

    handleValidation(callback){
        let { fields,brand_id} = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.name)){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }
        //name
        if(!brand_id){
            formIsValid = false;
            errors['brand'] = Translate.pleaseChooseABrand;
        }
        //Commission
        if(fields.commission !== null ) {
            if (parseInt(fields.commission) > 100 || parseInt(fields.commission) < 1) {
                formIsValid = false;
                errors['commission'] = Translate.between0to100;
            }
        }
        //Description
        if(fields.description !== null ) {
            if (fields.description.length > 600) {
                formIsValid = false;
                errors['description'] = Translate.maxLength600;
            }
        }
        if(!fields.pricing_status) {
            formIsValid = false;
            errors['pricing_status'] = Translate.emptyField;
        }
        if(fields.pricing_status === "present"){
            if(!fields.inventory){
                formIsValid = false;
                errors['inventory'] = Translate.emptyField;
            }
            if(!fields.priceR){
                formIsValid = false;
                errors['price'] = Translate.emptyField;
            }
            if(!fields.weight){
                formIsValid = false;
                errors['weight'] = Translate.emptyField;
            }
        }
        if(fields.discount_priceR !== null){
            if(fields.discount_priceR > 0){
                if(fields.discount_priceR >= fields.priceR){
                    formIsValid = false;
                    errors['discount_price'] = Translate.discountMoreThanPrice;
                }
            }
        }
        if(!!fields.inventory_for_wholesale && this.state.has_wholesale && fields.pricing_status === "present"){
            if(!fields.priceWholeR){
                formIsValid = false;
                errors['priceWhole'] = Translate.emptyField;
            }else if (fields.priceWholeR >= fields.priceR) {
                formIsValid = false;
                errors['priceWhole'] = Translate.wholesalePriceShouldBeLess;
            }
            if(!fields.inventory){
                formIsValid = false;
                errors['inventory'] = Translate.emptyField;
            }else if(parseInt(fields.inventory_for_wholesale) > parseInt(fields.inventory)){
                formIsValid = false;
                errors['inventory_for_wholesale'] = Translate.wholeSaleInventoryLessThanInventory;
            }
        }
        if(fields.discount_priceWholeR !== null){
            if(fields.discount_priceWholeR > 0){
                if(fields.discount_priceWholeR > fields.priceWholeR){
                    formIsValid = false;
                    errors['discount_priceWhole'] = Translate.discountMoreThanPrice;
                }
            }
        }
        if(!!fields.publish_year){
            if(parseInt(fields.publish_year) < 1000 && parseInt(fields.publish_year) > 3000){
                formIsValid = false;
                errors['publish_year'] = Translate.wrongYear;
            }
        }
        if(fields.situation === 'worked'){
            if(!fields.worked_status.length){
                formIsValid = false;
                errors['worked_status'] = Translate.emptyField;
            }
        }
        if(!formIsValid){
            console.log(errors);
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { id,fields,content,rating, book_file,has_discount_validity,discount_price_validity,cover_type,writers,has_wholesale,inside_pdf,translators,narrators,episodes,size,featured,brand_id,label_id,thumbnail,back_cover,advantages,disadvantages,is_not_original,variables,editMode,gallery,files,categories,keywords,confirmed,publish} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('english_name', fields.english_name);
        data.append('html', content.HTML);
        data.append('raw', content.RAW);
        data.append('shop_id', fields.shop_id);
        data.append('plainText', content.PlainText);
        data.append('id', id ? id : 0);
        data.append('description', fields.description);
        data.append('average_rating', rating);
        data.append('thumbnail', !!thumbnail ? thumbnail.id : 1);
        data.append('back_cover', !!back_cover ? back_cover.id : null);
        data.append('inside_pdf', !!inside_pdf ? inside_pdf.id : null);
        data.append('confirmed',confirmed ? 1 : 0);
        data.append('publish', publish ? 1 : 0);
        data.append('featured', featured ? 1 : 0);
        data.append('is_not_original', is_not_original ? 1 : 0);
        data.append('has_wholesale', has_wholesale ? 1 : 0);
        data.append('brand_id', !!brand_id ? brand_id : null);
        data.append('label_id', !!label_id ? label_id : null);
        data.append('cover_count', fields.cover_count);
        data.append('price', fields.priceR);
        data.append('discount_price', fields.discount_priceR);
        data.append('price_whole', fields.priceWholeR);
        data.append('discount_price_whole', fields.discount_priceWholeR);
        data.append('p_status', fields.pricing_status);
        data.append('inventory', fields.inventory);
        data.append('inventory_for_wholesale', fields.inventory_for_wholesale);
        data.append('commission', fields.commission);
        data.append('weight', fields.weight);
        data.append('publish_year', fields.publish_year);
        data.append('publish_turn', fields.publish_turn);
        data.append('physically', fields.physically);
        data.append('situation', fields.situation);
        data.append('number_of_pages', fields.number_of_pages);
        data.append('total_duration', fields.total_duration);
        data.append('book_file', !!book_file ? book_file.id : null);
        data.append('cover_type', cover_type);
        data.append('size', size);
        data.append('isbn', fields.isbn);
        data.append('worked_status', fields.worked_status.toString());
        data.append('advantages',JSON.stringify(advantages));
        data.append('disadvantages',JSON.stringify(disadvantages));
        data.append('variables', JSON.stringify(variables));
        data.append('categories', JSON.stringify(categories));
        data.append('keywords', JSON.stringify(keywords));
        data.append('discount_price_validity', (!!has_discount_validity && !!fields.discount_priceR) ? discount_price_validity : null);

        if(gallery !== null){
            let galery_ids = [];
            gallery.map((row) =>{
                galery_ids.push(row.id);
                return true
            })
            gallery = JSON.stringify(galery_ids);
        }
        data.append('gallery', gallery);
        if(files !== null){
            let files_ids = [];
            files.map((row) =>{
                files_ids.push(row.id);
                return true
            })
            files = JSON.stringify(files_ids);
        }
        data.append('book_files', files);

        if(writers !== null){
            let writers_ids = [];
            writers.map((row) =>{
                writers_ids.push(row.id);
                return true
            })
            writers = JSON.stringify(writers_ids);
        }
        data.append('writers', writers);

        if(translators !== null){
            let translators_ids = [];
            translators.map((row) =>{
                translators_ids.push(row.id);
                return true
            })
            translators = JSON.stringify(translators_ids);
        }
        data.append('translators', translators);

        if(narrators !== null){
            let narrators_ids = [];
            narrators.map((row) =>{
                narrators_ids.push(row.id);
                return true
            })
            narrators = JSON.stringify(narrators_ids);
        }
        data.append('narrators', narrators);

        data.append('episodes', JSON.stringify(episodes));

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let {user} = this.props;
        if(fields.inventory === 0 && fields.pricing_status === "present"){
            fields['pricing_status'] = "sold";
            this.setState({
                fields
            })
        }
        axios.post(`${defaultVariabls.url}/product/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.productEdited : Translate.productAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
                console.log(response.data)
                updateRedux();
                if(!!this.state.new_item){
                    this.props.history.push(`/create/product`);
                }
                if(!this.state.editMode){
                    if(!!user.role.permission.manageShops){
                        this.props.history.push(`/manage/products`);
                    }else{
                        this.props.history.push(`/my-products`);
                    }
                }
            })
            .catch(error => {
                console.log(error.response)
                if(error.response.status === 403){
                    if(error.response.data === "first_confirm_shop"){
                        this.props.enqueueSnackbar(Translate.firstConfirmShop, {
                            variant: 'error',
                        });
                        this.setState({
                            confirmed:0
                        })
                    }else{
                        this.props.enqueueSnackbar(editMode ?  Translate.productEditingFailed : Translate.productAddingFailed, {
                            variant: 'error',
                        });
                    }
                }else{
                    this.props.enqueueSnackbar(editMode ?  Translate.productEditingFailed : Translate.productAddingFailed, {
                        variant: 'error',
                    });
                }

                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    handleCheckProduct(){
        let {fields,errors} = this.state;

        if(!!fields.isbn){
            if(fields.isbn.length === 10 || fields.isbn.length === 13){
                this.setState({
                    checkLoading:true
                });
                let data = new FormData();
                data.append('isbn', fields.isbn);
                data.append('physically', fields.physically);
                data.append('situation', fields.situation);


                let loginToken = localStorage.getItem('ACT');
                let config = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`
                    }
                };
                let {user} = this.props;
                axios.post(`${defaultVariabls.url}/product/check`, data, config)
                    .then(response => {
                        let result = response.data;
                        if(parseInt(result.isbn) === 0){
                            errors['isbn'] = Translate.wrongISBN;
                            this.setState({
                                checkLoading:false,
                                errors
                            })
                        }else{
                            fields.isbn = result.isbn
                            if(result.product === null){
                                this.setState({
                                    initial_dialog:false,
                                    checkLoading:false,
                                    fields,
                                })
                            }else{
                                this.setState({
                                    existed_product:result.product,
                                    checkLoading:false,
                                    fields,
                                })
                            }
                        }

                    })
                    .catch(error => {
                        console.log(error.response)
                        this.setState({
                            checkLoading: false,
                        });
                    });
            }else{
                errors['isbn'] = Translate.wrongISBN;
                this.setState({
                    errors
                });
            }
        }else{
            this.setState({
                initial_dialog:false,
            })
        }
    }
    handleClickDescription(){
        let {fields,content} = this.state;
        if(fields['description'] === ''){
            fields['description'] = content.PlainText === null ? null : content.PlainText.slice(0, 600);
            this.setState({fields})
        }
    }
    handleSubmit(e = null,draft = false){
        this.setState({
            SubmitLoading: true
        })
        if(!!e){
            e.preventDefault();
        }
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }

    handleOutPut(code){
        this.setState({
            content:code
        })
    }
    handleCategoryHolder(categories){
        this.setState({categories})
    }
    handleVariablesHolder(variables){
        this.setState({variables})
    }
    handleGalleryChange(data){
        this.setState({
            gallery: data,
        })
    }
    handleFilesChange(data){
        this.setState({
            files: data,
        })
    }
    handleChangeConfirmed(){
        this.setState({
            confirmed: !this.state.confirmed,
        })
    }
    async handleChangePublish(){
        await this.setState({
            loading:true
        })
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        let data = new FormData();
        let {publish,id} = this.state;
        data.append('id', id);
        data.append('publish', !!publish ? 0 : 1);
        await axios.post(`${defaultVariabls.url}/product/publish_status`, data,config)
            .then(response => {
                this.setState({
                    loading:false,
                    publish:!this.state.publish
                })
                this.props.enqueueSnackbar(Translate.publishStatusChanged, {
                    variant: 'success',
                });
            }).catch(error => {
                console.log(error.response)
                this.setState({
                    loading:false
                })
            })
    }
    handleChangeFeatured(){
        this.setState({
            featured: !this.state.featured,
        })
    }
    async handleRequestToDelete(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariabls.url}/product/request_delete/${this.state.id}`, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.requestedToDelete, {
                    variant: 'success',
                });
                this.setState({
                   requested_to_delete:1,
                })
            }).catch(error => {
                console.log(error.response)
            })
    }
    handleDeleteProduct(){
        let data = new FormData();
        data.append('id', this.state.id);
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/delete/product`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.deleteProduct, {
                    variant: 'success',
                });
                this.props.history.push('/manage/products')
                return true
            })

            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.deleteProductFailed, {
                    variant: 'error',
                });
                return false
            });
    }
    async changeCategories(){
        await this.setState({
            categoriesName:[],
            categories:[],
            variables:[],
        })
    }
    openBMenu(event){
        this.setState({
            MBanchorEl:event.currentTarget
        })
    }
    openTMenu(event){
        this.setState({
            MTanchorEl:event.currentTarget
        })
    }
    openMMenu(event){
        this.setState({
            MManchorEl:event.currentTarget
        })
    }
    handleCloseBM(){
        this.setState({
            MBanchorEl:null,
            MTanchorEl:null,
            MManchorEl:null
        })
    }
    handleOptions(option){
        let {user} = this.props;
        if(option === "cancel"){
            if(!!user.role.permission.manageShops){
                this.props.history.push(`/manage/products`);
            }else{
                this.props.history.push(`/my-products`);
            }
        }else if(option === "new"){
            this.setState({
                new_item:true
            });
            this.handleSubmit()
        }else{
            this.handleSubmit()
        }
        this.handleCloseBM();

    }
    handleDiscountDate(date){
        this.setState({
            discount_price_validity:date
        })
    }
    handleRelatedProduct(prd){
        if(!!prd){
            this.setState({
                related_product:prd
            })
        }
    }
    handleEpisodes(episodes){
        this.setState({
            episodes
        })
        console.log(episodes)
    }
    render(){
        let {fields,brand_id,label_id,percent,rating,existed_product,featured,has_wholesale, percentWhole,errors,writers,translators,narrators,episodes,initial_dialog,gallery,files,slug,checkLoading,SubmitLoading,keywords,thumbnail,back_cover,inside_pdf,categories,categoriesName,content,editMode,confirmed,publish,editor_input_text} = this.state;
        const {user,primary_shop} = this.props;
        console.log(fields.cover_count_type);
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={editMode ? Translate.editProduct : Translate.makeProduct}>
            {
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} md={8} lg={9}>
                                <Grid container spacing={2} justifyContent="center">
                                    <Grid item xs={12}>
                                        <CheckForHavingShop new={!editMode} withoutShop={() => this.setState({initial_dialog:false,no_shop:true,})}/>
                                        {
                                            !editMode &&
                                            <Dialog
                                                fullWidth
                                                maxWidth="sm"
                                                open={this.state.initial_dialog}
                                            >
                                                <DialogTitle>
                                                    {Translate.initialInformationToMakeProduct}
                                                    {
                                                        existed_product &&
                                                        <Button
                                                            startIcon={<ChevronRightRoundedIcon/>}
                                                            size="small"
                                                            style={{float:"left"}}
                                                            onClick= {
                                                                () => this.setState({
                                                                    existed_product: null
                                                                })}
                                                        >
                                                            {Translate.back}
                                                        </Button>
                                                    }
                                                </DialogTitle>
                                                <DialogContent>
                                                    {
                                                        existed_product === null ?
                                                            <Grid container spacing={2}>
                                                                {
                                                                    fields.physically === "physical" &&
                                                                        <Grid item xs={12}>
                                                                            <Alert severity="info">
                                                                                {Translate.isbnDescription}
                                                                            </Alert>
                                                                        </Grid>
                                                                }
                                                                <Grid item xs={12}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        required
                                                                        value={fields.physically}
                                                                        fullWidth
                                                                        select
                                                                        label={Translate.physically}
                                                                        name="physically"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['physically']}
                                                                        helperText={errors['physically']}
                                                                    >
                                                                        <MenuItem value="physical">
                                                                            {Translate.physical}
                                                                        </MenuItem>
                                                                        {/*<MenuItem value="audiobook">
                                                                            {Translate.audiobook}
                                                                        </MenuItem>
                                                                        <MenuItem value="ebook">
                                                                            {Translate.ebook}
                                                                        </MenuItem>*/}
                                                                    </TextField>
                                                                </Grid>
                                                                {
                                                                    fields.physically === "physical" &&
                                                                    <>
                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                fullWidth
                                                                                name="isbn"
                                                                                variant="outlined"
                                                                                label={Translate.isbn}
                                                                                placeholder={Translate.isbnHelper}
                                                                                type="number"
                                                                                id="isbn"
                                                                                value={fields.isbn}
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['isbn']}
                                                                                helperText={errors['isbn']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                required
                                                                                value={fields.situation}
                                                                                fullWidth
                                                                                select
                                                                                label={Translate.situation}
                                                                                name="situation"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['situation']}
                                                                                helperText={errors['situation']}
                                                                            >
                                                                                <MenuItem value="new">
                                                                                    {Translate.new}
                                                                                </MenuItem>
                                                                                <MenuItem value="worked">
                                                                                    {Translate.worked}
                                                                                </MenuItem>
                                                                            </TextField>
                                                                        </Grid>
                                                                    </>
                                                                }
                                                                {
                                                                    fields.physically !== "physical" &&
                                                                    <Grid item xs={12}>
                                                                        <PhysicalProductChooser
                                                                            outPut={(prd) => this.handleRelatedProduct(prd)}
                                                                            label={Translate.chooseRelatedProduct}
                                                                        />
                                                                    </Grid>

                                                                }
                                                            </Grid>
                                                            :
                                                            <Grid contianer spacing={2}>
                                                                <Grid container spacing={2} justifyContent="center" alignItems="center">
                                                                    <Grid item xs={12} md={11}>
                                                                        <Alert severity="info">
                                                                            <AlertTitle>
                                                                                {Translate.isbnIsExistHead}
                                                                            </AlertTitle>
                                                                            {Translate.isbnIsExist}
                                                                        </Alert>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={11}>
                                                                        <div style={{
                                                                            display:"flex",
                                                                            flexDirection:"row",
                                                                            alignItems:"center",
                                                                            justifyContent:"space-between",
                                                                            border:"1px solid #fbfbfb",
                                                                            padding:10,
                                                                            borderRadius:4
                                                                        }}>
                                                                            <div style={{display:"flex",flexDirection:"row",alignItems:"center"}}>
                                                                                <div>
                                                                                    <img style={{width:75}} src={`${defaultVariabls.uploads}/FileManager/${existed_product.thumbnail.name}_small.${existed_product.thumbnail.extension}`} />
                                                                                </div>
                                                                                <div style={{marginRight:10}}>
                                                                                    <Typography style={{fontSize:13}}><strong>{existed_product.name}</strong></Typography>
                                                                                    <Typography style={{fontSize:12}}>{existed_product.isbn}</Typography>
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <Button
                                                                                    size="small"
                                                                                    color="primary"
                                                                                    style={{marginLeft:10}}
                                                                                    startIcon={<PageviewRoundedIcon/>}
                                                                                    component="a"
                                                                                    href={`${defaultVariabls.website}/product/${existed_product.slug}`}
                                                                                >
                                                                                    {Translate.viewProduct}
                                                                                </Button>
                                                                                {
                                                                                    user.id === existed_product.user_id &&
                                                                                    <Button
                                                                                        size="small"
                                                                                        color="primary"
                                                                                        variant="contained"
                                                                                        component={Link}
                                                                                        to={`/edit/product/${existed_product.id}`}
                                                                                    >
                                                                                        {Translate.editProduct}
                                                                                    </Button>
                                                                                }

                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                    }

                                                </DialogContent>
                                                <DialogActions style={{display:"flex",justifyContent:"space-between"}}>
                                                    <Button
                                                        onClick={() => this.handleOptions('cancel')}
                                                        variant="contained"
                                                    >
                                                        {Translate.cancel}
                                                    </Button>
                                                    {
                                                        existed_product === null ?
                                                            <LoadingButton
                                                                onClick = {this.handleCheckProduct.bind(this)}
                                                                loading = {checkLoading}
                                                                color="primary"
                                                                variant="contained"
                                                                endIcon={<ArrowBackRoundedIcon/>}
                                                            >
                                                                {Translate.resume}
                                                            </LoadingButton>
                                                            :
                                                            <Button
                                                                component={Link}
                                                                to={`/pricing/product/${existed_product.id}`}
                                                                color="primary"
                                                                variant="contained"
                                                                endIcon={<ArrowBackRoundedIcon/>}
                                                            >
                                                                {Translate.goToPricing}
                                                            </Button>
                                                    }
                                                </DialogActions>
                                            </Dialog>
                                        }
                                        {
                                            !this.state.no_shop &&
                                            <AppCard
                                                title={editMode ? Translate.editProduct : Translate.makeProduct}
                                                action={
                                                    <BreadCrumbs singleLevel firstText={editMode ? Translate.editProduct : Translate.makeProduct}/>
                                                }>
                                                {
                                                    this.state.loading ? <AppCardLoaderFields/> :
                                                        <Grid container spacing={2}   style={{marginBottom:10}}>
                                                            {/*{
                                                                (!!editMode && this.props.user.role.type === "admin") &&
                                                                <Grid item xs={12}>
                                                                    <Alert
                                                                        severity="info"
                                                                        action={
                                                                            <FormControlLabel
                                                                                style={{marginRight:10,color: !publish ? "#ed1d1d" : ""}}
                                                                                control={
                                                                                    <Switch
                                                                                        checked={publish}
                                                                                        onChange={this.handleChangePublish.bind(this)}
                                                                                        value={publish}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label={publish ? Translate.published : Translate.draft}
                                                                            />
                                                                        }
                                                                    >
                                                                        <AlertTitle>{Translate.publishStatus}</AlertTitle>
                                                                        {Translate.publishStatusDesc}
                                                                    </Alert>
                                                                </Grid>
                                                            }*/}
                                                            <Grid item xs={12}>
                                                                {
                                                                    !editMode ?
                                                                        null
                                                                        :
                                                                        <>
                                                                            {
                                                                                !! user.role.permission.manageShops ?
                                                                                    <>
                                                                                        {
                                                                                            this.state.product_shop.confirmed === 0 &&
                                                                                                <Alert
                                                                                                    style={{marginBottom:15}}
                                                                                                    severity="error"
                                                                                                    action={
                                                                                                    <Button
                                                                                                        size="small"
                                                                                                        variant="outlined"
                                                                                                        component={Link}
                                                                                                        to={`/edit/shop/${this.state.product_shop.id}`}
                                                                                                    >
                                                                                                        {Translate.manageShop}
                                                                                                    </Button>
                                                                                                    }
                                                                                                    >
                                                                                                    {Translate.shopIsNotConfirmed}
                                                                                                </Alert>
                                                                                        }
                                                                                        <Alert
                                                                                            severity="info"
                                                                                            action={
                                                                                                <FormControlLabel
                                                                                                    style={{marginRight:10,color: !confirmed ? "#ed1d1d" : ""}}
                                                                                                    control={
                                                                                                        <Switch
                                                                                                            checked={confirmed}
                                                                                                            onChange={this.handleChangeConfirmed.bind(this)}
                                                                                                            value={confirmed}
                                                                                                            color="primary"
                                                                                                        />
                                                                                                    }
                                                                                                    label={confirmed ? Translate.confirmed : Translate.unConfirmed}
                                                                                                />
                                                                                            }
                                                                                        >
                                                                                            {Translate.confirmationStatusDescription}
                                                                                        </Alert>
                                                                                    </>
                                                                                    :
                                                                                    confirmed ?
                                                                                        <Alert severity="success">
                                                                                            {Translate.yourProductIsActive}
                                                                                        </Alert>
                                                                                        :
                                                                                        <Alert severity="warning">
                                                                                            {Translate.yourProductIsInchecking}
                                                                                        </Alert>
                                                                            }
                                                                        </>

                                                                }
                                                            </Grid>
                                                            {
                                                                (initial_dialog === false && (fields.isbn !== 0 && !!fields.isbn)) &&
                                                                <Grid item xs={12}>
                                                                    <div style={{display:"flex",alignItems:"center"}}>
                                                                        <Typography style={{marginLeft:10}}>{Translate.physically}: {Translate[fields.physically]}</Typography>

                                                                        {
                                                                            fields.physically === "physical" &&
                                                                            <Typography style={{marginLeft:10}}>{Translate.isbn}: <strong>{fields.isbn}</strong></Typography>
                                                                        }

                                                                        {
                                                                            fields.physically === "physical" &&
                                                                            <Typography style={{marginLeft:10}}>{Translate.situation}: <strong>{Translate[fields.situation]}</strong></Typography>
                                                                        }
                                                                        {
                                                                            !!this.state.unique_code &&
                                                                            <Typography> {Translate.unique_code}: <strong>{this.state.unique_code}</strong> </Typography>

                                                                        }

                                                                    </div>


                                                                </Grid>
                                                            }
                                                            {
                                                                (initial_dialog === false && !fields.isbn) &&
                                                                <Grid item xs={12}>
                                                                    <div style={{display:"flex",alignItems:"center"}}>
                                                                        <Typography style={{marginLeft:10}}>{Translate.physically}: {Translate[fields.physically]}</Typography>
                                                                        {
                                                                            fields.physically === "physical" &&
                                                                                <Typography style={{marginLeft:10}}>{Translate.isbn}: <strong>{Translate.isNotExist}</strong> <AddISBNToBook id={this.state.id} reload={() => this.loadData()}/></Typography>
                                                                        }
                                                                        {
                                                                            fields.physically === "physical" &&
                                                                            <Typography>{Translate.situation}: <strong>{Translate[fields.situation]}</strong></Typography>
                                                                        }
                                                                        {
                                                                            !!this.state.related_product &&
                                                                            <Typography> {Translate.related_product}: <strong>{this.state.related_product.name}</strong> </Typography>

                                                                        }
                                                                    </div>
                                                                </Grid>
                                                            }
                                                            {
                                                                fields.situation === "worked" &&
                                                                <Grid item xs={12} lg={6}>
                                                                    <Autocomplete
                                                                        multiple
                                                                        required
                                                                        limitTags={2}
                                                                        options={worked_statuses}
                                                                        getOptionLabel={(option) => option}
                                                                        value={fields.worked_status}
                                                                        onChange={(event, newValue) => {
                                                                            let {fields,errors} = this.state;
                                                                            fields['worked_status'] = newValue;
                                                                            errors['worked_status'] = "";

                                                                            this.setState({
                                                                                fields,
                                                                                errors
                                                                            })

                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                label={Translate.worked_status}
                                                                                size="small"
                                                                                variant="outlined"
                                                                                fullwidth
                                                                                required
                                                                                error = {!!errors['worked_status']}
                                                                                helperText={errors['worked_status']}
                                                                            />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                }
                                            </AppCard>
                                        }

                                    </Grid>
                                    {
                                        fields.physically === "audiobook" &&
                                        <Grid item xs={12}>
                                            <AppCard>
                                                {
                                                    this.state.loading ? <AppCardLoaderFields/> :
                                                        <EpisodeMaker
                                                            episodes={episodes}
                                                            handleEpisodes={(episodes) => this.handleEpisodes(episodes)}
                                                        />
                                                }
                                            </AppCard>
                                        </Grid>
                                    }
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <SubTitle align="left">{Translate.bookInformation}</SubTitle>
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                required
                                                                size="small"
                                                                fullWidth
                                                                name="name"
                                                                variant="outlined"
                                                                label={Translate.productName}
                                                                placeholder={Translate.productName}
                                                                type="text"
                                                                id="name"
                                                                value={fields.name}
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['name']}
                                                                helperText={errors['name']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                variant="outlined"
                                                                value={fields.number_of_pages}
                                                                fullWidth
                                                                size="small"
                                                                type="number"
                                                                label={Translate.number_of_pages}
                                                                name="number_of_pages"
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['number_of_pages']}
                                                                helperText={errors['number_of_pages']}
                                                            />
                                                        </Grid>
                                                        {
                                                            fields.physically === "audiobook" &&
                                                            <Grid item xs={12} md={6}>
                                                                <TextField
                                                                    variant="outlined"
                                                                    value={fields.total_duration}
                                                                    fullWidth
                                                                    size="small"
                                                                    type="number"
                                                                    label={Translate.total_duration}
                                                                    name="total_duration"
                                                                    onChange={this.handleChange.bind(this)}
                                                                    error = {!!errors['total_duration']}
                                                                    helperText={errors['total_duration']}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                {Translate.minute}
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}
                                                                />
                                                            </Grid>
                                                        }

                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                variant="outlined"
                                                                value={fields.publish_year}
                                                                fullWidth
                                                                size="small"
                                                                type="number"
                                                                label={Translate.publish_year}
                                                                name="publish_year"
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['publish_year']}
                                                                helperText={errors['publish_year']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                variant="outlined"
                                                                value={fields.publish_turn}
                                                                fullWidth
                                                                size="small"
                                                                type="number"
                                                                label={Translate.publish_turn}
                                                                name="publish_turn"
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['publish_turn']}
                                                                helperText={errors['publish_turn']}
                                                            />
                                                        </Grid>
                                                        {
                                                            fields.physically === "physical" &&
                                                                <>
                                                                    <Grid item xs={12} md={6}>
                                                                        <SizeChooser
                                                                            input={this.state.size}
                                                                            output={(size) => this.setState({size})}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}  md={6}>
                                                                        <CoverChooser
                                                                            input={this.state.cover_type}
                                                                            output={(cover_type) => this.setState({cover_type})}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={12}  md={6}>
                                                                        <TextField
                                                                            variant="outlined"
                                                                            select
                                                                            size="small"
                                                                            fullWidth
                                                                            name="cover_count_type"
                                                                            label={Translate.has_multi_cover}
                                                                            type="text"
                                                                            value={fields.cover_count_type}
                                                                            onChange={this.handleChange.bind(this)}

                                                                        >
                                                                            <MenuItem  value={"single"}>
                                                                                {Translate.singleCover}
                                                                            </MenuItem>
                                                                            <MenuItem  value={"multi"}>
                                                                                {Translate.multiCover}
                                                                            </MenuItem>
                                                                        </TextField>
                                                                    </Grid>
                                                                    {
                                                                        fields.cover_count_type === "multi" &&
                                                                        <Grid item xs={12}  md={6}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                type='number'
                                                                                size="small"
                                                                                fullWidth
                                                                                name="cover_count"
                                                                                label={Translate.cover_count}
                                                                                value={fields.cover_count}
                                                                                onChange={this.handleChange.bind(this)}
                                                                            />
                                                                        </Grid>
                                                                    }

                                                                </>
                                                        }
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <SubTitle align="left">{Translate.pricingProduct}</SubTitle>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TextField
                                                                select
                                                                required
                                                                type="text"
                                                                size="small"
                                                                fullWidth
                                                                label={Translate.pricing_status}
                                                                name="pricing_status"
                                                                value={fields.pricing_status}
                                                                onChange={this.handleChange.bind(this)}
                                                                variant="outlined"
                                                                error={!!errors['pricing_status']}
                                                            >
                                                                <MenuItem value={'present'}>
                                                                    {Translate.present_pricing}
                                                                </MenuItem>
                                                                <MenuItem value={'sold'}>
                                                                    {Translate.sold_pricing}
                                                                </MenuItem>
                                                                <MenuItem value={'soon'}>
                                                                    {Translate.soon_pricing}
                                                                </MenuItem>
                                                            </TextField>
                                                        </Grid>
                                                        <Grid item xs={12} md={6} >
                                                            <CurrencyTextField
                                                                required={fields.pricing_status === "present"}
                                                                variant="outlined"
                                                                fullWidth
                                                                size="small"
                                                                currencySymbol={currencySymbol}
                                                                decimalPlaces={0}
                                                                value={fields.price}
                                                                id="price"
                                                                label={Translate.price}
                                                                name="price"
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['price']}
                                                                helperText={errors['price']}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4} md={2}>
                                                            <TextField
                                                                variant="outlined"
                                                                value={percent}
                                                                fullWidth
                                                                id="percent"
                                                                size="small"
                                                                label={Translate.discount_percent}
                                                                name="percent"
                                                                autoComplete="percent"
                                                                onChange={this.handleChangePercent.bind(this)}
                                                                error = {!!errors['percent']}
                                                                helperText={errors['percent']}
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={8} md={4}>
                                                            <CurrencyTextField
                                                                variant="outlined"
                                                                fullWidth
                                                                size="small"
                                                                currencySymbol={currencySymbol}
                                                                decimalPlaces={0}
                                                                value={fields.discount_price}
                                                                id="discount_price"
                                                                label={Translate.discount_price}
                                                                name="discount_price"
                                                                onChange={this.handleChange.bind(this)}
                                                                error = {!!errors['discount_price']}
                                                                helperText={errors['discount_price']}
                                                            />
                                                        </Grid>
                                                        {
                                                            fields.discount_priceR > 0 &&
                                                            <>
                                                                <Grid item xs={12} md={!!this.state.has_discount_validity ? 6 : 12}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={this.state.has_discount_validity}
                                                                                onChange={(e) => this.setState({has_discount_validity: !this.state.has_discount_validity})}
                                                                                name="has_discount_validity"
                                                                                color="primary"
                                                                            />
                                                                        }
                                                                        label={Translate.has_discount_validity}
                                                                    />

                                                                </Grid>
                                                                {
                                                                    !!this.state.has_discount_validity &&
                                                                    <Grid item xs={12} md={6} style={{display:"flex",justifyContent:"flex-end"}}>
                                                                        <FullTimeChooserModal
                                                                            input={this.state.discount_price_validity}
                                                                            handleDate={this.handleDiscountDate.bind(this)}
                                                                            label={Translate.discountDate}
                                                                        />
                                                                    </Grid>
                                                                }
                                                            </>
                                                        }

                                                        {
                                                            fields.physically === "physical" &&
                                                            <>
                                                            {
                                                                fields.pricing_status === "present" &&
                                                                    <Grid item xs={12} md={6}>
                                                                        <TextField
                                                                            required
                                                                            variant="outlined"
                                                                            value={fields.inventory}
                                                                            fullWidth
                                                                            size="small"
                                                                            type="number"
                                                                            label={Translate.inventory}
                                                                            placeholder={Translate.inventoryDesc}
                                                                            name="inventory"
                                                                            onChange={this.handleChange.bind(this)}
                                                                            error = {!!errors['inventory']}
                                                                            helperText={errors['inventory']}
                                                                        />
                                                                    </Grid>
                                                            }

                                                                <Grid item xs={12} md={6}>
                                                                    <TextField
                                                                        required={fields.pricing_status === "present"}
                                                                        variant="outlined"
                                                                        value={fields.weight}
                                                                        fullWidth
                                                                        size="small"
                                                                        type="number"
                                                                        label={Translate.weight}
                                                                        name="weight"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['weight']}
                                                                        helperText={!!errors['weight'] ? errors['weight'] : Translate.weightHelper}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    {Translate.gram}
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            {
                                                                (fields.situation !== "worked" && fields.pricing_status === "present") &&
                                                                <>
                                                                    <Grid item xs={12}>
                                                                        <FormControl required component="fieldset">
                                                                            <FormControlLabel
                                                                                control={<Checkbox checked={has_wholesale} onChange={() => this.setState({has_wholesale:!has_wholesale})} />}
                                                                                label={Translate.activeWholesale}
                                                                            />

                                                                        </FormControl>
                                                                    </Grid>
                                                                    {
                                                                        !!this.state.has_wholesale &&
                                                                        <>
                                                                            <Grid item xs={12} md={6}>
                                                                                <TextField
                                                                                    variant="outlined"
                                                                                    value={fields.inventory_for_wholesale}
                                                                                    fullWidth
                                                                                    size="small"
                                                                                    type="number"
                                                                                    label={Translate.inventory_for_wholesale}
                                                                                    placeholder={Translate.inventoryWholeSaleDesc}
                                                                                    name="inventory_for_wholesale"
                                                                                    onChange={this.handleChange.bind(this)}
                                                                                    error = {!!errors['inventory_for_wholesale']}
                                                                                    helperText={errors['inventory_for_wholesale']}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} md={6} >
                                                                                <CurrencyTextField
                                                                                    variant="outlined"
                                                                                    fullWidth
                                                                                    size="small"
                                                                                    currencySymbol={currencySymbol}
                                                                                    decimalPlaces={0}
                                                                                    value={fields.priceWhole}
                                                                                    id="priceWhole"
                                                                                    label={Translate.priceWhole}
                                                                                    name="priceWhole"
                                                                                    onChange={this.handleChange.bind(this)}
                                                                                    error = {!!errors['priceWhole']}
                                                                                    helperText={errors['priceWhole']}
                                                                                />
                                                                            </Grid>
                                                                            {/* <Grid item xs={4} md={2}>
                                                                        <TextField
                                                                            variant="outlined"
                                                                            value={percentWhole}
                                                                            fullWidth
                                                                            size="small"
                                                                            label={Translate.discount_percent_whole}
                                                                            name="percentWhole"
                                                                            onChange={this.handleChangePercentWhole.bind(this)}
                                                                            error = {!!errors['percentWhole']}
                                                                            helperText={errors['percentWhole']}
                                                                            InputProps={{
                                                                                startAdornment: <InputAdornment position="start">%</InputAdornment>,
                                                                            }}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={8} md={4}>
                                                                        <CurrencyTextField
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            size="small"
                                                                            currencySymbol={currencySymbol}
                                                                            decimalPlaces={0}
                                                                            value={fields.discount_priceWhole}
                                                                            label={Translate.discount_priceWhole}
                                                                            name="discount_priceWhole"
                                                                            onChange={this.handleChange.bind(this)}
                                                                            error = {!!errors['discount_priceWhole']}
                                                                            helperText={errors['discount_priceWhole']}
                                                                        />
                                                                    </Grid>*/}
                                                                        </>
                                                                    }
                                                                </>

                                                            }

                                                            </>
                                                        }

                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <AppCard style={{height:"100%"}}>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <LinearCategoryHolder
                                                                outPut={this.handleCategoryHolder.bind(this)}
                                                                inPut={categoriesName} editMode={categoriesName.length === 0 ? false : editMode}/>
                                                        </Grid>
                                                        {
                                                            !!editMode && !!categoriesName.length &&
                                                            <Grid item xs={12}>
                                                                <Button
                                                                    size="small"
                                                                    variant="outlined"
                                                                    onClick={() => this.changeCategories()}
                                                                >
                                                                    {Translate.changeCategories}
                                                                    </Button>
                                                            </Grid>
                                                        }

                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <AppCard style={{height:"100%"}}>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <BrandChooser
                                                        required
                                                        title={Translate.brand}
                                                        initial={brand_id}
                                                        changeBrand={(brand_id) => this.setState({brand_id})}
                                                        error={errors['brand']}
                                                    />
                                            }

                                        </AppCard>
                                    </Grid>
                                    {
                                        fields.physically === "virtual" &&
                                        <Grid item xs={12}>
                                            <AppCard>
                                                {
                                                    this.state.loading ? <AppCardLoaderFields/> :
                                                        <>
                                                            <Grid item xs={12}>
                                                                <Grid item xs={12}>
                                                                    <SubTitle>{Translate.bookFile}</SubTitle>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <ProtectedFileUploader
                                                                    handleFile={(file) => this.setState({book_file: file})}
                                                                    title={Translate.uploadBook}
                                                                />
                                                                {
                                                                    this.state.book_file !== null &&
                                                                    <Button
                                                                        component="a"
                                                                        href={`${defaultVariabls.website}/download-protected-file/${ this.state.book_file.id}`}
                                                                    >
                                                                        {Translate.viewUploadedFile}
                                                                    </Button>
                                                                }
                                                            </Grid>
                                                        </>
                                                }
                                            </AppCard>
                                        </Grid>
                                    }
                                    <Grid item xs={12} md={fields.physically === "audiobook" ? 4 : 6}>
                                        <AppCard
                                            style={{height:"100%"}}
                                            >
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <SubTitle
                                                                align="left">{Translate.writersType}</SubTitle>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <WritersChooser input={writers} output={(writers) => this.setState({writers})}/>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12} md={fields.physically === "audiobook" ? 4 : 6}>
                                        <AppCard
                                            style={{height:"100%"}}
                                        >
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <SubTitle
                                                                align="left">{Translate.translatorsType}</SubTitle>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <TranslatorsChooser input={translators} output={(translators) => this.setState({translators})}/>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    {
                                        fields.physically === "audiobook" &&
                                        <Grid item xs={12} md={4}>
                                            <AppCard
                                                style={{height:"100%"}}
                                            >
                                                {
                                                    this.state.loading ? <AppCardLoaderFields/> :
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <SubTitle
                                                                    align="left">{Translate.narratorsType}</SubTitle>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <NarratorsChooser input={narrators} output={(narrators) => this.setState({narrators})}/>
                                                            </Grid>
                                                        </Grid>
                                                }
                                            </AppCard>
                                        </Grid>
                                    }

                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                            this.state.loading ? <AppCardLoaderFields/> :
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <SubTitle align="left">{Translate.productDescription}</SubTitle>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <RichEditor inputText={editor_input_text} ref={this.EditorChild} Output={this.handleOutPut.bind(this)} input={content.RAW}/>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            margin="normal"
                                                            multiline
                                                            fullWidth
                                                            name="description"
                                                            label={Translate.seoDescription}
                                                            placeholder={Translate.seoDescription}
                                                            type="text"
                                                            id="description"
                                                            rows="4"
                                                            value={fields.description}
                                                            onChange={this.handleChange.bind(this)}
                                                            onClick={this.handleClickDescription.bind(this)}
                                                            error={!!errors['description']}
                                                            helperText={errors['description']}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <FieldCounterWithoutBar length={fields.description.length} max={600}/>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    {/*<Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12}>
                                                            <SubTitle align="left">{Translate.keywordsLabel}</SubTitle>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Keywords input={keywords}
                                                                      handleChange={(keywords) => this.setState({keywords})}/>
                                                            <Typography
                                                                variant="body2"
                                                                style={{marginTop: 10, fontWeight: 700}}
                                                            >
                                                                {Translate.keywordsDescription}
                                                                <br/>
                                                            </Typography>
                                                            <Typography>
                                                                {Translate.pressEnterAfterEachKeyword}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>*/}
                                    <Hidden smDown>
                                        <Grid item xs={12}>
                                            <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                <Button
                                                    variant="contained"
                                                    style={{marginLeft:15}}
                                                    onClick={() => this.handleOptions('cancel')}
                                                >
                                                    {Translate.cancel}
                                                </Button>
                                                <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="secondary"
                                                        style={{borderBottomLeftRadius:0,borderTopLeftRadius:0,minWidth:100}}
                                                        onClick = {this.handleSubmit.bind(this)}
                                                        loading = {SubmitLoading}
                                                    >
                                                        {Translate.save}
                                                    </LoadingButton>
                                                    <IconButton
                                                        className="glue_iconbtn"
                                                        onClick={this.openBMenu.bind(this)}
                                                    >
                                                        <KeyboardArrowDownRoundedIcon/>
                                                    </IconButton>
                                                    <Menu
                                                        anchorEl={this.state.MBanchorEl}
                                                        keepMounted
                                                        open={ Boolean(this.state.MBanchorEl)}
                                                        onClose={() => this.handleCloseBM()}
                                                    >
                                                        <MenuItem  onClick={() => this.handleOptions('publish')}>
                                                            {Translate.saveAndPublish}
                                                        </MenuItem>
                                                        <MenuItem  onClick={() => this.handleOptions('new')}>
                                                            {Translate.saveAndNewProduct}
                                                        </MenuItem>
                                                        <MenuItem  onClick={() => this.handleOptions('cancel')}>
                                                            {Translate.cancelLong}
                                                        </MenuItem>

                                                    </Menu>
                                                </div>
                                            </div>
                                        </Grid>
                                    </Hidden>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <Grid container spacing={2} alignItems="center" justify="center">
                                    <Hidden smDown>
                                        <Grid item xs={12} style={{paddingTop: 0}}>
                                            <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                <Button
                                                    variant="contained"
                                                    style={{marginLeft:15}}
                                                    onClick={() => this.handleOptions('cancel')}
                                                >
                                                    {Translate.cancel}
                                                </Button>
                                                <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="secondary"
                                                        style={{borderBottomLeftRadius:0,borderTopLeftRadius:0,minWidth:150}}
                                                        onClick = {this.handleSubmit.bind(this)}
                                                        loading = {SubmitLoading}
                                                    >
                                                        {Translate.save}
                                                    </LoadingButton>
                                                    <IconButton
                                                        className="glue_iconbtn"
                                                        onClick={this.openTMenu.bind(this)}
                                                    >
                                                        <KeyboardArrowDownRoundedIcon/>
                                                    </IconButton>
                                                    <Menu
                                                        anchorEl={this.state.MTanchorEl}
                                                        keepMounted
                                                        open={ Boolean(this.state.MTanchorEl)}
                                                        onClose={() => this.handleCloseBM()}
                                                    >
                                                        <MenuItem  onClick={() => this.handleOptions('publish')}>
                                                            {Translate.saveAndPublish}
                                                        </MenuItem>
                                                        <MenuItem  onClick={() => this.handleOptions('new')}>
                                                            {Translate.saveAndNewProduct}
                                                        </MenuItem>
                                                        <MenuItem  onClick={() => this.handleOptions('cancel')}>
                                                            {Translate.cancelLong}
                                                        </MenuItem>

                                                    </Menu>
                                                </div>
                                            </div>
                                            <div style={{marginLeft:15,marginRight:15}}>
                                                {
                                                    !!editMode ?
                                                        user.id === this.state.owner_id && !user.role.permission.manageShops && !this.state.requested_to_delete &&
                                                        <Button
                                                            startIcon={<DeleteRoundedIcon/>}
                                                            style={{color:"#fff",backgroundColor:"#ff5451",width:"100%"}}
                                                            onClick={() => this.handleRequestToDelete()}
                                                        >
                                                            {Translate.requestToDeleteProduct}
                                                        </Button>
                                                        : null
                                                }
                                                {
                                                    !!editMode ?
                                                        !!user.role.permission.manageShops &&
                                                        <GetConfirmationText
                                                            variant="outlined"
                                                            style={{color:"#fff",backgroundColor:"#ff5451",width:"100%"}}
                                                            tooltip={Translate.removeProduct}
                                                            handleAction={() => this.handleDeleteProduct()}
                                                        >
                                                            {Translate.removeProduct}
                                                        </GetConfirmationText>
                                                        : null
                                                }
                                            </div>
                                        </Grid>
                                    </Hidden>
                                    {
                                        (!!editMode && !!confirmed) &&
                                            <Grid item xs={12}>
                                                <AppCard>
                                                    {
                                                        this.state.loading ? <AppCardLoaderFields/> :
                                                            <>
                                                                <Button
                                                                    component="a"
                                                                    target="_blank"
                                                                    size="small"
                                                                    startIcon={<PageviewRoundedIcon/>}
                                                                    href={`${defaultVariabls.website}/product/${slug}`}
                                                                    color="primary"
                                                                >
                                                                    {Translate.viewProduct}
                                                                </Button>
                                                                <Typography className='date-holder'>
                                                                    <span>
                                                                        {Translate.updated_at}
                                                                    </span>
                                                                    <span>
                                                                        {`${moment(this.state.updated_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                                                                    </span>
                                                                </Typography>
                                                                <Typography  className='date-holder'>
                                                                    <span>{Translate.created_at}</span>
                                                                    <span>
                                                                            {`${moment(this.state.created_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}
                                                                    </span>
                                                                </Typography>

                                                            </>
                                                    }
                                                </AppCard>
                                            </Grid>
                                    }
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12}>
                                                            <SubTitle>{Translate.front_cover}</SubTitle>
                                                            <SingleImageChooser
                                                                primary
                                                                onChange={(thumbnail) => this.handleThumbImage(thumbnail)}
                                                                initial={thumbnail}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <SubTitle>{Translate.back_cover}</SubTitle>
                                                            <SingleImageChooser
                                                                primary
                                                                onChange={(back_cover) => this.setState({back_cover})}
                                                                initial={back_cover}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            {
                                                                fields.physically === "audiobook" ?
                                                                    <SingleFileChooser
                                                                        title={Translate.epAudioFile}
                                                                        initial={inside_pdf}
                                                                        onChange={(file) => this.setState({inside_pdf:file})}
                                                                        type="audio"
                                                                        align="center"
                                                                    />
                                                                    :
                                                                    <SingleFileChooser
                                                                        title={Translate.inside_pdf}
                                                                        initial={inside_pdf}
                                                                        onChange={(file) => this.setState({inside_pdf:file})}
                                                                        type="document"
                                                                        align="center"
                                                                    />
                                                            }

                                                        </Grid>
                                                        <Grid item xs={12} style={{marginTop:30}}>
                                                            <SubTitle>{Translate.gallery}</SubTitle>
                                                            <ImageGallery onChange={this.handleGalleryChange.bind(this)} initial={gallery}/>
                                                        </Grid>
                                                        <Grid item xs={12} style={{marginTop:30}}>
                                                            <SubTitle>{Translate.files}</SubTitle>
                                                            <FilesChooser onChange={this.handleFilesChange.bind(this)} initial={files}/>
                                                        </Grid>
                                                    </Grid>
                                            }
                                        </AppCard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <AppCard>
                                            {
                                                this.state.loading ? <AppCardLoaderFields/> :
                                                    <LabelChooser
                                                        title={Translate.productLabel}
                                                        initial={label_id}
                                                        changeLabel={(label_id) => this.setState({label_id})}
                                                    />
                                            }

                                        </AppCard>
                                    </Grid>
                                    <Feature check="marketplace">
                                    <Grid item xs={12}>
                                    <AppCard>
                                        {
                                            this.state.loading ? <AppCardLoaderFields/> :
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item xs={12} style={{paddingBottom: 0}}>
                                                        <SubTitle align="left">{Translate.relatedShop}</SubTitle>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {
                                                            editMode ?
                                                                <TextField
                                                                    margin="normal"
                                                                    required
                                                                    type="text"
                                                                    fullWidth
                                                                    disabled
                                                                    label={Translate.shopName}
                                                                    value={fields.shop_name}
                                                                    variant="outlined"
                                                                /> :
                                                                <TextField
                                                                    select
                                                                    margin="normal"
                                                                    required
                                                                    type="text"
                                                                    fullWidth
                                                                    label={Translate.chooseShop}
                                                                    name="shop_id"
                                                                    value={fields.shop_id}
                                                                    onChange={this.handleChange.bind(this)}
                                                                    variant="outlined"
                                                                    error={!!errors['shop_id']}
                                                                    helperText={!!errors['shop_id'] ? errors['shop_id'] : Translate.chooseShopHelperText}
                                                                >
                                                                    {
                                                                        user.role.type === "admin" &&
                                                                            !!primary_shop &&
                                                                        <MenuItem value={primary_shop.id}>
                                                                            {primary_shop.name}
                                                                        </MenuItem>
                                                                    }
                                                                    {user.shops.map((option) => (
                                                                        <MenuItem key={option.id} value={option.id}>
                                                                            {option.name}
                                                                        </MenuItem>
                                                                    ))}
                                                                </TextField>
                                                        }
                                                    </Grid>
                                                </Grid>
                                        }
                                    </AppCard>
                                </Grid>
                                    </Feature>
                         {/*           {
                                        !!user.role.permission.manageShops ?
                                            <Grid item xs={12}>
                                                <AppCard>
                                                    {
                                                        this.state.loading ? <AppCardLoaderFields/> :
                                                            <Grid container spacing={2} alignItems="center">
                                                                <Grid item xs={12}>
                                                                    <SubTitle align="left">{Translate.managementSetting}</SubTitle>
                                                                </Grid>
                                                                <Feature check="marketplace">
                                                                <Grid item xs={12}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        value={fields.commission}
                                                                        fullWidth
                                                                        label={Translate.commission}
                                                                        name="commission"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['commission']}
                                                                        helperText={errors['commission']}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    %
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                </Feature>
                                                                <Grid item xs={12}>
                                                                    <Typography>{Translate.productTotalRating}:</Typography>
                                                                    <Rating
                                                                        name="rating"
                                                                        precision={0.5}
                                                                        value={rating}
                                                                        onChange={(event, newValue) => {
                                                                            this.setState({
                                                                                rating:newValue,
                                                                            })
                                                                        }}
                                                                    />
                                                                    <Typography className="litle_description_text">{Translate.productTotalRatingDesc}</Typography>
                                                                </Grid>
                                                                <Feature check="featured_products">
                                                                <Grid item xs={12}>
                                                                    <Alert
                                                                        severity="info"
                                                                        variant="outlined"
                                                                        icon={<StarRoundedIcon fontSize="small" />}
                                                                        action={
                                                                            <FormControlLabel
                                                                                style={{marginRight:10}}
                                                                                control={
                                                                                    <Switch
                                                                                        checked={featured}
                                                                                        onChange={this.handleChangeFeatured.bind(this)}
                                                                                        value={featured}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label={featured ? Translate.yes : Translate.no}
                                                                            />
                                                                        }
                                                                    >
                                                                        <Typography style={{fontSize:13}}>{Translate.featuredProduct}</Typography>
                                                                    </Alert>
                                                                </Grid>
                                                                </Feature>
                                                            </Grid>
                                                    }
                                                </AppCard>
                                            </Grid>
                                            : null
                                    }*/}
                                    <Hidden mdUp>
                                        <Grid item xs={12} style={{paddingTop: 0}}>
                                            <div style={{display:"flex",alignItems:"center",justifyContent:"center",marginBottom:10}}>
                                                <Button
                                                    variant="contained"
                                                    style={{marginLeft:15}}
                                                    onClick={() => this.handleOptions('cancel')}
                                                >
                                                    {Translate.cancel}
                                                </Button>
                                                <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="secondary"
                                                        style={{borderBottomLeftRadius:0,borderTopLeftRadius:0,minWidth:150}}
                                                        onClick = {this.handleSubmit.bind(this)}
                                                        loading = {SubmitLoading}
                                                    >
                                                        {Translate.save}
                                                    </LoadingButton>
                                                    <IconButton
                                                        className="glue_iconbtn small"
                                                        onClick={this.openMMenu.bind(this)}
                                                    >
                                                        <KeyboardArrowDownRoundedIcon/>
                                                    </IconButton>
                                                    <Menu
                                                        anchorEl={this.state.MManchorEl}
                                                        keepMounted
                                                        open={ Boolean(this.state.MManchorEl)}
                                                        onClose={() => this.handleCloseBM()}
                                                    >
                                                        <MenuItem  onClick={() => this.handleOptions('publish')}>
                                                            {Translate.saveAndPublish}
                                                        </MenuItem>
                                                        <MenuItem  onClick={() => this.handleOptions('new')}>
                                                            {Translate.saveAndNewProduct}
                                                        </MenuItem>
                                                        <MenuItem  onClick={() => this.handleOptions('cancel')}>
                                                            {Translate.cancelLong}
                                                        </MenuItem>

                                                    </Menu>
                                                </div>
                                            </div>

                                        </Grid>
                                    </Hidden>
                                    <Hidden mdUp>
                                        <Grid item xs={12}>
                                            {
                                                !!editMode ?
                                                    user.id === this.state.owner_id && !user.role.permission.manageShops && !this.state.requested_to_delete &&
                                                    <Button
                                                        startIcon={<DeleteRoundedIcon/>}
                                                        style={{color:"#fff",backgroundColor:"#ff5451"}}
                                                        onClick={() => this.handleRequestToDelete()}
                                                    >
                                                        {Translate.requestToDeleteProduct}
                                                    </Button>
                                                    : null
                                            }
                                            {
                                                !!editMode ?
                                                    !!user.role.permission.manageShops &&
                                                    <GetConfirmationText
                                                        variant="outlined"
                                                        style={{color:"#fff",backgroundColor:"#ff5451"}}
                                                        tooltip={Translate.removeProduct}
                                                        handleAction={() => this.handleDeleteProduct()}
                                                    >
                                                        {Translate.removeProduct}
                                                    </GetConfirmationText>
                                                    : null
                                            }
                                        </Grid>
                                    </Hidden>
                                </Grid>
                            </Grid>
                        </Grid>

                }
            </AppAnimate>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,

});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MakeProduct))));